import {localStorageApi} from '../../api/storage';
import {decode} from '../../services/common';
import {COOKIES_USER_STORE_KEY} from '../../constants/cookies';

function initialUserModel() {
  const stringData = localStorageApi.get(COOKIES_USER_STORE_KEY);
  if (stringData) {
    try {
      return decode(stringData);
    } catch (e) {
      console.log(e);
      return {};
    }
  }

  return {};
}

export {initialUserModel};
